import { useCircleV4 } from "@circle-react/hooks/useCircleV4";

import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/SettingsApp/CompassCompat/Typography";

import { getAnimationDelay } from "./animations";
import { SummaryHeaderV4 } from "./SummaryHeaderV4";

interface SpaceSummaryHeaderProps {
  formattedDateRange: string;
  sourceName: string;
}

export const SummaryHeader = (props: SpaceSummaryHeaderProps) => {
  const { isCircleV4 } = useCircleV4();
  if (isCircleV4) return <SummaryHeaderV4 {...props} />;
  return <SummaryHeaderLegacy {...props} />;
};

const SummaryHeaderLegacy = ({
  formattedDateRange,
  sourceName,
}: SpaceSummaryHeaderProps) => (
  <div
    className="text-tertiary animate-fade-in-slow mb-2 text-sm opacity-0"
    style={{
      animationDelay: getAnimationDelay(0),
      animationFillMode: "forwards",
    }}
  >
    {formattedDateRange} {t("ai_spaces_summaries.bullet")}{" "}
    {t("ai_spaces_summaries.summary_of")}
    <div
      className="animate-fade-in-slow opacity-0"
      style={{
        animationDelay: getAnimationDelay(1),
        animationFillMode: "forwards",
      }}
    >
      <Typography.TitleMd>{sourceName}</Typography.TitleMd>
    </div>
  </div>
);
